import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Divider, Stack, Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import StoreItem from './store-item'
import NoSearchResults from './no-search-results'

const Stores = ({stores, setStores, setStoreDetails, setEditStore, hideNoSearchResults}) => {
    if (stores === null) {
        return null
    }

    return (
        <Stack gap="20px">
            {stores.length ? (
                <Box
                    position="sticky"
                    top="0"
                    zIndex="1"
                    backgroundColor="white"
                    paddingX="20px"
                    paddingBottom="5px"
                    borderBottom="1px solid"
                    borderColor="gray.550"
                >
                    <Text
                        color="black"
                        fontSize="14px"
                        fontWeight="300"
                        lineHeight="20px"
                        letterSpacing="0.5px"
                    >
                        <FormattedMessage
                            id="select_store_modal.nearest_stores"
                            defaultMessage="Nearest Stores"
                        />
                    </Text>
                </Box>
            ) : (
                <></>
            )}

            {stores.length ? (
                <Stack gap="0" divider={<Divider borderColor="gray.550" marginY="0 !important" />}>
                    {stores.map((store) => (
                        <StoreItem
                            key={store.ID}
                            store={store}
                            setStores={setStores}
                            setStoreDetails={setStoreDetails}
                            setEditStore={setEditStore}
                        />
                    ))}
                </Stack>
            ) : (
                <NoSearchResults hideNoSearchResults={hideNoSearchResults} />
            )}
        </Stack>
    )
}

Stores.propTypes = {
    stores: PropTypes.arrayOf(
        PropTypes.shape({
            ID: PropTypes.string,
            name: PropTypes.string,
            distance: PropTypes.string,
            calloutMessage: PropTypes.string,
            phone: PropTypes.string,
            address1: PropTypes.string,
            city: PropTypes.string,
            stateCode: PropTypes.string,
            zip: PropTypes.string
        })
    ),
    setStores: PropTypes.func.isRequired,
    hideNoSearchResults: PropTypes.func.isRequired,
    setStoreDetails: PropTypes.func.isRequired,
    setEditStore: PropTypes.func.isRequired
}

export default Stores
